<template>
  <v-dialog
    v-model="show"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    persistent
    transition="dialog-bottom-transition"
    scrollable
    max-width="80%"
  >
    <v-card>
      <v-toolbar text dark color="primary" style="max-height: 65px;">
        <v-btn icon dark class="hidden-md-and-up" @click="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Neue Zeiterfassung</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon :disabled="!submitAllowed" dark class="hidden-md-and-up" text @click.native="createServiceTracking">
            <span class="hidden-xs-only">Speichern</span>
            <v-icon right>save</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="serviceTrackingForm.valid">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                :items="customers"
                item-value="id"
                return-object
                v-model="selectedCustomer"
                label="Kunde"
                required
                :rules="mandatoryFieldRule"
                append-outer-icon="help"
                @click:append-outer="showInfos = !showInfos"
              >
                <template slot="selection" slot-scope="data">
                  <v-list-item-content>
                    <v-list-item-title>{{data.item.lastName}} {{data.item.firstName}}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-item-content>
                    <v-list-item-title>{{data.item.lastName}} {{data.item.firstName}}</v-list-item-title>
                    <v-list-item-subtitle>{{data.item.street}}, {{data.item.zipCode}} {{data.item.city}}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>
              <v-dialog
                v-model="showInfos"
              >
                <v-card>
                  <v-app-bar flat dark color="primary">
                    <v-toolbar-title>Hinweise</v-toolbar-title>
                  </v-app-bar>
                  <v-card>
                    <v-card-text v-if="selectedCustomer && selectedCustomer.infos">
                      {{selectedCustomer.infos}}
                    </v-card-text>
                    <v-card-text v-else>
                      Keine Hinweise vorhanden.
                    </v-card-text>
                  </v-card>
                </v-card>
              </v-dialog>
            </v-flex>
            <v-flex xs12>
              <v-select
                :items="services"
                item-text="name"
                item-value="id"
                return-object
                v-model="serviceTrackingForm.service"
                label="Dienstleistung"
                required
                :rules="mandatoryFieldRule"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="warning" icon="warning">
                    Bitte zuerst einen Kunden auswählen
                  </v-alert>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <el-date-picker
                v-model="serviceTrackingForm.date"
                type="date"
                placeholder="Datum auswählen"
                :default-value="today"
                format="dd.MM.yyyy"
                value-format="timestamp"
                :rules="mandatoryFieldRule"
                :picker-options="datePickerOptions"
              >
              </el-date-picker>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <el-time-select
                placeholder="Startzeit auswählen"
                format="HH:mm"
                value-format="timestamp"
                v-model="serviceTrackingForm.startTime"
                :picker-options="timerPickerOptions"
                :rules="mandatoryFieldRule"
              >
              </el-time-select>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <el-time-select
                placeholder="Endzeit auswählen"
                format="HH:mm"
                value-format="timestamp"
                v-model="serviceTrackingForm.finishTime"
                :picker-options="{
                  start: timerPickerOptions.start,
                  step: timerPickerOptions.step,
                  end: timerPickerOptions.end,
                  minTime: serviceTrackingForm.startTime
                }"
                :rules="mandatoryFieldRule"
              >
              </el-time-select>
            </v-flex>
          </v-layout>
        </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="hidden-sm-and-down">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">Abbrechen</v-btn>
        <v-btn
          :disabled="!submitAllowed"
          color="primary"
          text
          @click.native="createServiceTracking">
          Speichern
        </v-btn>
      </v-card-actions>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'NewServiceTrackingDialog',
    props: ['show'],
    data () {
      return {
        today: this.getToday(),
        services: [],
        selectedCustomer: null,
        showInfos: false,
        serviceTrackingForm: {
          valid: false,
          customer: null,
          service: null,
          date: this.getDefaultDate(),
          startTime: null,
          finishTime: null
        },
        datePickerOptions: {
          disabledDate (date) {
            const today = new Date()
            const priorDate = new Date(new Date().setDate(today.getDate() - 60))
            return date < priorDate || date > today
          }
        },
        timerPickerOptions: {
          start: '07:00',
          step: '00:15',
          end: '22:00'
        },
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ]
      }
    },
    computed: {
      customers: function () {
        return this.$store.getters.user.customers
      },
      submitAllowed () {
        return this.serviceTrackingForm.customer !== null &&
          this.serviceTrackingForm.service !== null &&
          this.serviceTrackingForm.date !== null &&
          this.serviceTrackingForm.startTime !== null &&
          this.serviceTrackingForm.finishTime !== null
      }
    },
    watch: {
      selectedCustomer: function (newCustomer) {
        if (newCustomer) {
          this.serviceTrackingForm.customer = newCustomer
          const definitions = this.customers.find(customer => customer.id === newCustomer.id).customerServiceDefinitions
          definitions.forEach(definition => this.services.push(definition.service))
        }
      }
    },
    methods: {
      createServiceTracking () {
        const currentUser = this.$store.getters.user
        this.$store.dispatch('addServiceTracking', {
          user: {id: currentUser.id, email: currentUser.username, roles: currentUser.roles},
          service: this.serviceTrackingForm.service,
          customer: this.serviceTrackingForm.customer,
          startTime: this.calcTime(this.serviceTrackingForm.date, this.serviceTrackingForm.startTime),
          finishTime: this.calcTime(this.serviceTrackingForm.date, this.serviceTrackingForm.finishTime)
        })
          .finally(() => this.close())
      },
      getToday () {
        return new Date().toJSON().slice(0, 10)
      },
      getDefaultDate () {
        return new Date().setHours(0, 0, 0, 0)
      },
      calcTime (date, time) {
        const t = time.split(':')
        return date + (t[0] * 60 * 60000 + t[1] * 60000)
      },
      close () {
        this.clearForm()
        this.$emit('close')
      },
      clearForm () {
        this.$refs.form.reset()
        this.services = []
        this.serviceTrackingForm = initialState()
        this.today = this.getToday()
      }
    }
  }

  function initialState () {
    return {
      valid: false,
      customer: null,
      service: null,
      date: null,
      startTime: null,
      finishTime: null
    }
  }
</script>

<style>
  .el-date-editor.el-input {
    width: 100%;
  }
  .el-date-table td.today span {
    color: white;
    background-color: #409EFF75;
    border-radius: 50%;
  }
  .el-date-table td.current:not(.disabled) span {
    background-color: #2e7d32;
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceTracking/NewServiceTrackingDialog.vue